import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type SearchHistoryStoreType = {
    history: string[];
    addHistory: (query: string) => void;
    removeHistory: (query: string) => void;
    clearHistory: () => void;
};

const MAX_HISTORY_ITEMS = 5;

export const useSearchHistoryStore = create<SearchHistoryStoreType>()(
    persist(
        immer((set) => ({
            history: [],
            addHistory: (query) =>
                set((state) => {
                    const normalizedQuery = query.trim();
                    if (!normalizedQuery) return;
                    state.history = [normalizedQuery, ...state.history.filter((item) => item !== normalizedQuery)].slice(0, MAX_HISTORY_ITEMS);
                }),
            removeHistory: (query) =>
                set((state) => {
                    state.history = state.history.filter((item) => item !== query);
                }),
            clearHistory: () =>
                set((state) => {
                    state.history = [];
                })
        })),
        {
            name: 'azki-service-search-history',
            partialize: (state) => ({ history: state.history })
        }
    )
);
